import {DataObjectImageDescriptor, TexturesApiService} from "@app/textures/service/textures-api.service"
import {ImageOpDataObjectPageSupplier} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/image-op-data-object-page-supplier"
import {ImageOpDataObjectPageSupplierFullImage} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/image-op-data-object-page-supplier-full-image"
import {assertNever} from "@cm/utils"
import {ImageOpDataObjectPageSupplierPaged} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/image-op-data-object-page-supplier-paged"
import {ImageOpDataObjectManagerCallback} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/image-op-data-object-manager-callback"

export class ImageOpDataObject {
    constructor(
        callback: ImageOpDataObjectManagerCallback,
        texturesApi: TexturesApiService,
        readonly descriptor: DataObjectImageDescriptor,
        downloadFormat: DownloadFormat,
    ) {
        if (downloadFormat === "tiles" && !descriptor.imageTilesDescriptor) {
            texturesApi.logger.debug("Tiles download format requested but not available, falling back to JPG")
            downloadFormat = "jpg"
        }
        switch (downloadFormat) {
            case "exr":
            case "jpg":
                texturesApi.logger.debug(`Loading full image as ${downloadFormat} for data object`, descriptor)
                this.pageSupplier = new ImageOpDataObjectPageSupplierFullImage(texturesApi, descriptor, downloadFormat)
                break
            case "tiles":
                texturesApi.logger.debug("Loading tiles format for data object", descriptor)
                this.pageSupplier = new ImageOpDataObjectPageSupplierPaged(callback, descriptor)
                break
            default:
                assertNever(downloadFormat)
        }
    }

    readonly pageSupplier: ImageOpDataObjectPageSupplier
}

export type DownloadFormat = "exr" | "jpg" | "tiles"
